import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";

import {
    ItemContainer,
    StyledLegendContainer,
} from "app/pages/sales-intelligence/sub-modules/opportunities/components/modals/WebsitesModal/styles";

export const ItemIconContainer = styled(ItemIcon)`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    text-align: center;
    cursor: default;
    justify-content: center;
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon["0"]};
    box-shadow: 0 2px 4px 0 rgba(202, 202, 202, 0.2);
    border: solid 1px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
`;

export const CompanyInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 16px;
`;

export const CompanyName = styled.div`
    display: flex;
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["400"])}
`;

export const CompanySubTitle = styled.div`
    display: inline-block;
    width: 385px;
    ${mixins.setFontVariant("listItem3", colorsPalettes.carbon["300"])}
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const StyledCompanyLegendContainer = styled(StyledLegendContainer)`
    display: flex;
    flex-direction: row;
`;

export const CompanyItemContainer = styled(ItemContainer)`
    padding: 8px 16px;
`;
